import { Component, Input, OnInit } from '@angular/core';
import {CorePrincipleModel} from "./model/core-principle.model";

@Component({
    selector: 'app-core-principles',
    templateUrl: './core-principles.component.html',
    styleUrls: ['./core-principles.component.scss']
})

export class CorePrinciplesComponent implements OnInit {
    @Input()  corePrinciples: Array<CorePrincipleModel> = [];
    @Input()  leadershipPrinciples: Array<CorePrincipleModel> = [];
    ngOnInit() {
        
    }
}